import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_grid2d, use_slice_ui, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { REMOTE__generation_start } from '@/state/generation/status/REMOTE__generation_start';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { ENUM__generation_status } from '@shared/dto/generation/_enums/ENUM__generation_status';
import { DTO_REQUEST__generation_start } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_start';
import { DTO__grid2d_generation } from '@shared/dto/grid2d/DTO__grid2d_generation';
import { useRef } from 'react';

export function WATCHER_GENERATION__autorun() {
  /*
   * STORE
   */

  const dispatch = use_dispatch();
  const { generation_current } = use_slice_generation(['generation_current']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { user_settings } = use_slice_user(['user_settings']);
  const { g_general__layout } = use_slice_ui(['g_general__layout']);
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);

  /*
   * STATE
   */
  const ref_ids_in_progress = useRef(new Set<string>());

  /*
   * EFFECTS
   */

  use_effect(() => {
    void start_autorun_nodes();
  }, [generation_current, user_settings, grids2d_map, g_general__layout]);

  /*
   * METHODS
   */
  async function start_autorun_nodes() {
    let allowed_statuses = [ENUM__generation_status.ADJUSTING, ENUM__generation_status.STOPPED];

    if (generation_current.is_stub()) return;
    if (!allowed_statuses.includes(generation_current.status)) return;
    if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)) return;
    if (!user_settings.generation_autorun) return;
    if (!generation_current.tool.graph.meta.errors.is_empty()) return;
    if (!CONSTANTS__client.LAYOUTS_WITH_AUTORUN.includes(g_general__layout)) return; //no need to autorun on other layouts
    if (!grids2d_map.has(generation_current._id)) return; //not loaded yet
    if (ref_ids_in_progress.current.has(generation_current._id)) return; //already running

    let grid2d = grids2d_map.get_or_assert(generation_current._id);
    assert_instanceof(grid2d, DTO__grid2d_generation);

    if (grid2d.get_generation_chunk().images_to_generate_amount == 0) return; //no images to generate

    ref_ids_in_progress.current.add(generation_current._id);

    let request = new DTO_REQUEST__generation_start();
    request.generation_id = generation_current._id;
    request.ml_asset_reservation_id = ENUM__string_id_empty.OBJECT_ID;

    await dispatch(REMOTE__generation_start(request));

    ref_ids_in_progress.current.delete(generation_current._id);
  }

  return null;
}
